import { render, staticRenderFns } from "./EditorialImports.vue?vue&type=template&id=7413952e&"
import script from "./EditorialImports.vue?vue&type=script&lang=js&"
export * from "./EditorialImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports